<template>
  <div>
    <top-bar title="Minhas Entregas"/>
    <div class="content pt-0">
      <div class="container mb-3">
        <c-offline class="mb-3" v-if="online === false"/>
        <download-app home="true"/>
        <div class="d-flex mb-3 history-search">
          <input type="date" class="form-control mr-2" v-model="pesquisa.data">
          <div class="text-nowrap history-search__action">
            <button class="btn btn-primary" @click="getPedidos">
              <i class="fa-solid fa-search mr-1"></i> Buscar
            </button>
          </div>
        </div>
        <div class="row no-gutters history-cards" v-if="pedidos.length">
          <div class="col-6 pr-2">
            <div class="card history-card shadow-sm">
              <div class="card-body text-center">
                <div class="history-card__icon"><i class="fa-solid fa-motorcycle"></i></div>
                <div class="history-card__value">{{ totalEntregas }}</div>
                <div class="history-card__label">Qtd de Entregas</div>
              </div>
            </div>
          </div>
          <div class="col-6 pl-2">
            <div class="card history-card shadow-sm">
              <div class="card-body text-center">
                <div class="history-card__icon"><i class="fa-solid fa-wallet"></i></div>
                <div class="history-card__value">{{ totalTaxas | valor }}</div>
                <div class="history-card__label">Valor das Taxas</div>
              </div>
            </div>
          </div>
        </div>
        <div class="history-divider" v-if="pedidos.length"><span>Pedidos</span></div>
      </div>

      <loading v-if="load" class="mt-5" text="Por favor aguarde"/>
      <div class="container" v-show="!load">
        <div class="mb-3" v-for="pedido in pedidos" :key="pedido.id_pedido">
          <div class="card card-pedido" tabindex="1">
            <pedido :p="pedido" status="3" @openPedido="openPedido"/>
          </div>
        </div>
        <div class="text-center mt-4" v-if="!pedidos.length">
          <div class="pt-4 mb-3 empty-state">
            <img v-show="online === false" src="@/assets/illustrations/semconexao.png" alt="Ilustração de dispositivo sem conexão" class="empty-state__img">
            <img v-show="online" src="@/assets/illustrations/finalizados-sempedidos.png" alt="Ilustração de entregador" class="empty-state__img">
            <span class="empty-state__title" v-if="online === false">Sem conexão com a internet</span>
            <span class="empty-state__title" v-else>Nenhum pedido entregue nesta data</span>
          </div>
        </div>
      </div>
    </div>

    <info-pedido ref="infoPedido" @openGps="openGps"/>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar';
import Loading from '@/components/Loading';
import COffline from '@/components/COffline';
import DownloadApp from '@/components/DownloadApp';
import Pedido from '@/components/Pedido';
import InfoPedido from '@/views/InfoPedido';

export default {
  name: 'Historico',
  components: { TopBar, Loading, COffline, DownloadApp, Pedido, InfoPedido },

  data() {
    return {
      load: false,
      pesquisa: {
        status: '3',
        data: new Date().toDateInputValue()
      },
      pedidos: [],
      resumo: { qtd_entregas: 0, total_taxas: 0 }
    };
  },

  computed: {
    empresa() {
      return this.$store.state.user;
    },

    online() {
      return this.$store.state.online;
    },

    totalEntregas() {
      return this.resumo.qtd_entregas || 0;
    },

    totalTaxas() {
      return this.resumo.total_taxas || 0;
    }
  },

  methods: {
    getPedidos() {
      if (this.load) return;

      this.load = true;
      this.pedidos = [];
      this.resumo = { qtd_entregas: 0, total_taxas: 0 };

      this.$http.get('v2/entregador/pedidos', { params: this.pesquisa })
        .then(response => {
          const payload = response.data || {};
          const pedidos = payload.pedidos || [];
          const resumo = payload.resumo || {};

          this.pedidos = pedidos.slice().sort((a, b) =>
            parseInt(a.ordem_entrega || '1') - parseInt(b.ordem_entrega || '1')
          );
          this.resumo = {
            qtd_entregas: Number(resumo.qtd_entregas || 0),
            total_taxas: Number(resumo.total_taxas || 0)
          };
          this.load = false;
        }, () => {
          this.load = false;
        });
    },

    openPedido(pedido) {
      this.$refs.infoPedido.openPedido(pedido);
    },

    openGps(selecionado) {
      const destination = selecionado.lat_endereco && selecionado.long_endereco
        ? `${selecionado.lat_endereco},${selecionado.long_endereco}`
        : encodeURI(`${selecionado.logradouro}, ${selecionado.numero || ''}, ${this.empresa.nome_cidade} - ${this.empresa.sigla_estado}`);
      window.open(`https://www.google.com/maps/dir/?api=1&destination=${destination}&travelmode=driving`, '_blank');
    }
  },

  mounted() {
    this.getPedidos();
  }
};
</script>

<style scoped>
.card-pedido { padding: 18px 18px 0; border: 1px solid var(--border-color); cursor: pointer; border-radius: 28px; }
.history-search .btn { min-width: 156px; }
.history-search__action { width: 156px; }
.history-cards { margin: 0 -4px 18px; }
.history-divider { position: relative; margin: 2px 0 18px; text-align: center; }
.history-divider::before { content: ""; position: absolute; left: 0; right: 0; top: 50%; border-top: 1px solid var(--border-color); }
.history-divider span { position: relative; display: inline-block; padding: 0 12px; background-color: var(--bg-theme); color: var(--text-muted); font-size: 0.96rem; font-weight: 600; }
.history-card { border-radius: 22px; }
.history-card .card-body { padding: 16px 12px 14px; }
.history-card__icon { width: 44px; height: 44px; margin: 0 auto 10px; border-radius: 16px; background-color: rgba(199, 244, 123, 0.28); border: 1px solid rgba(199, 244, 123, 0.36); color: #a3c613; display: flex; align-items: center; justify-content: center; font-size: 1rem; }
.dark-mode .history-card__icon { background-color: rgba(199, 244, 123, 0.16); border-color: rgba(199, 244, 123, 0.2); color: var(--primary); }
.history-card__value { font-size: 1rem; line-height: 1.2rem; font-weight: 700; color: var(--text-default); }
.history-card__label { margin-top: 6px; font-size: 0.82rem; line-height: 1rem; color: var(--text-muted); }
.content.pt-0 { padding-bottom: 32px; }
.empty-state { max-width: 420px; margin: 0 auto; padding: 0 18px 4px; display: flex; flex-direction: column; align-items: center; transform: translateY(12px); }
.empty-state__img { width: min(100%, 228px); height: auto; margin-bottom: 8px; }
.empty-state__title { max-width: 280px; font-size: 1rem; line-height: 1.28rem; font-weight: 700; color: var(--text-default); }
</style>
